import { isDayjs } from 'dayjs';
import { IEstimateFormData } from '.';

export const serializeAndValidateFormData = (formData: IEstimateFormData) => {
  const serializedFormData = { ...formData };
  if (isDayjs(serializedFormData.estimateDate)) {
    serializedFormData.estimateDate = serializedFormData.estimateDate.format('YYYY-MM-DD');
  }

  if (isDayjs(serializedFormData.dueDate)) {
    serializedFormData.dueDate = serializedFormData.dueDate.format('YYYY-MM-DD');
  }

  return { formData: serializedFormData, isValid: true, errorMsg: '' };
};
